<template>
    <b-modal size="md" button-size="sm" hide-footer :visible="showModal" :title="prefix + title" @abort="cancelar"
        @hidden="cancelar" @close="cancelar">
        <b-form @submit.prevent="save">
            <b-card>
                <b-container fluid>
                    <b-row class="justify-content-center">
                        <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" "
                            :error="$v.form.descricao" v-model="form.descricao" label="Descrição:" cols="12" sm="8"
                            md="12" />
                    </b-row>

                    <b-row class="justify-content-center">
                        <b-form-group label="Status:" class="text-center">
                            <b-form-radio-group v-model="form.situacao" class="d-inline-block">
                                <b-form-radio :value="1">Ativo</b-form-radio>
                                <b-form-radio :value="0">Inativo</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-row>

                    <b-row class="justify-content-center mt-2">
                        <b-button type="submit" variant="success" class="mr-2" size="sm">
                            <b-icon icon="check-circle" />
                        </b-button>
                        <b-button @click="cancelar" variant="danger" size="sm">
                            <b-icon icon="x-circle" />
                        </b-button>
                    </b-row>
                </b-container>
            </b-card>
        </b-form>
    </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { FormResourceMixin } from "@/core/mixins/resource"
import TipoMedidaService from "@/core/api/TipoMedidaService"

export default {
    components: {
        LgFormInput,
    },

    mixins: [FormResourceMixin],

    props: {
        id: Number,
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Cadastro",
        },
        showModal: {
            type: Boolean,
            default: true,
        },
    },
    validations: {
        form: {
            descricao: { required },
            situacao: { required },
        },
    },
    data() {
        return {
            form: {
                descricao: "",
                situacao: 1,
            },
        }
    },
    async beforeMount() {
        this.$TipoMedidaService = new TipoMedidaService()
    },
    async mounted() {
        if (this.id) {
            const { data } = await this.$TipoMedidaService.findById(this.id)
            this.form = data
        }
    },
    methods: {
        async save() {
            if (!this.formIsValid) {
                this.$v.$touch()
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                })
                return
            }
            try {
                await this.$TipoMedidaService.save(this.form)
                this.$notify({
                    type: "success",
                    message: "Registro salvo com sucesso",
                });

                this.$emit("update:showModal", false)
                this.$emit("close")
            } catch (e) {
                this.$notify({
                    type: "danger",
                    message: "Ocorreu um erro ao salvar o cadastro.",
                })
            }
        },

        cancelar() {
            this.$emit("update:showModal", false)
            this.$emit("close")
        },
    },
}
</script>
